import { render, staticRenderFns } from "./template_preview.vue?vue&type=template&id=61138704&scoped=true&"
import script from "./template_preview.vue?vue&type=script&lang=js&"
export * from "./template_preview.vue?vue&type=script&lang=js&"
import style0 from "./template_preview.vue?vue&type=style&index=0&id=61138704&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61138704",
  null
  
)

export default component.exports